import { Dispatch, ReactNode, SetStateAction } from 'react'
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react'
import { cn } from '@/lib/utils.ts'
import { Input } from './input/Input.tsx'

export type ListItem = { id: number | string; name: string }

type MultipleSelectorProps = {
  list: ListItem[]
  selected: ListItem[]
  setSelected: Dispatch<SetStateAction<ListItem[]>>
  className?: string
  icon: ReactNode
  readOnly?: boolean
  placeHolder?: string
}

export default function MultipleSelector({
  list,
  selected,
  setSelected,
  readOnly,
  className,
  icon,
  placeHolder = 'Select Filter',
}: MultipleSelectorProps) {
  return (
    <Listbox
      value={selected}
      disabled={readOnly}
      onChange={setSelected}
      multiple
    >
      {/*<Label className="block text-sm font-medium leading-6 text-gray-900">*/}
      {/*  Assigned to*/}
      {/*</Label>*/}
      <div className={cn('relative', className)}>
        <ListboxButton className="relative w-full cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6 min-w-[250px] w-full">
          <span className="block truncate">
            {selected.length == 0
              ? placeHolder
              : selected.length == 1
                ? selected[0].name
                : `${selected.length} Selected`}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            {icon}
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute   z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {list.map((listItem) => (
            <ListboxOption
              key={listItem.id}
              value={listItem}
              className="group text-sm relative cursor-default select-none py-2 pl-3 pr-9 text-gray-800 data-[focus]:bg-primary-600 data-[focus]:text-white"
            >
              <span className="absolute inset-y-0 left-2 flex items-center pr-4 text-primary-600 group-data-[focus]:text-white">
                <Input
                  id={`create-${listItem.id}`}
                  type="checkbox"
                  checked={selected.some((s) => s.id === listItem.id)}
                  readOnly
                />
              </span>
              <span className="block font-normal group-data-[selected]:font-semibold ml-6">
                {listItem.name}
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  )
}
